function setCookie(name,value,days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days*24*60*60*1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "")  + expires + "; path=/";
}

function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for(var i=0;i < ca.length;i++) {
        var c = ca[i];
        while (c.charAt(0)==' ') c = c.substring(1,c.length);
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
    }
    return null;
}

let loaded = false;

function openCart() {
    document.body.classList.add('cart-opened');
    
    if (!loaded) {
        fetch('/?section_id=cart-checkout-buttons')
            .then(response => response.text())
            .then(html => {
                const container = document.querySelector('.additional-checkout-buttons');
                if (container) {
                    container.innerHTML = html;
                }
                loaded = true;
            })
            .catch(error => console.log('Error loading checkout buttons:', error));
    }
}

function closeCart() {
    document.body.classList.remove('cart-opened');
}

function showLoader() {
    $('.bins-cart-loader').show();
}

function hideLoader() {
    $('.bins-cart-loader').hide();
}

function formatPrice(num) {
    return Number(num).toFixed(2)
        .replace(/\B(?=(\d{3})+(?!\d))/g, ',');
}

const VAT_RATE = 0.20;

function addVat(price) {
    return price * (1 + VAT_RATE);
}

function removeVat(price) {
    return price / (1 + VAT_RATE);
}

function isVatIncluded() {
    return $('#vat-switch').is(':checked');
}

async function getVariant(variant_id) {
    try {
        const response = await fetch(
            "https://app.wheeliebins.co.uk/api/get-variant", {
                method: "POST",
                headers: {
                "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    variant_id
                }),
            }
        );
        
        if (!response.ok) {
            throw new Error('Network response was not ok');
        }        
        
        const data = await response.json();
        console.log(data);
        return data;
    } catch (error) {
        console.error('There was a problem with the fetch operation:', error);
        throw error;
    }
}

async function renderCartDrawer() {
    let sub_total = 0;

    try {
        const res = await fetch(window.Shopify.routes.root + "cart.js");
        const cart = await res.json();

        const $itemsContainer = $(".bins-cart-items");
        const $totalsContainer = $(".bins-cart-totals");

        $itemsContainer.empty();

        if (cart.items.length) {
            for (const item of cart.items) {
                let item_title = item.product_title;
                let item_image = item.featured_image.url;
                let item_price = item.price;

                if (item_price === 0 || item_title === undefined) {
                    const variant_data = await getVariant(item.variant_id);
                    console.log(variant_data);

                    item_title = variant_data.title;
                    item_image = variant_data.image;
                    item_handle = variant_data.handle;
                    item_price = variant_data.price * variant_data.qtty;
                } else {
                    item_price = item.presentment_price * item.quantity;
                    item_title = item.product_title;
                    item_image = item.image;
                }

                sub_total += item_price;

                const formattedPrice = formatPrice(item_price.toFixed(2));

                let propertiesHtml = '';
                for (const key in item.properties) {
                    if (item.properties[key]) {
                        propertiesHtml += `
                            <p class="item-property">
                                <span>${key}:</span> ${item.properties[key]}
                            </p>
                        `;
                    }
                }

                $itemsContainer.append(`
                    <div class="bins-cart-item cwrap" data-id="${item.id}">
                        <div class="cart-item-image">
                            <a href="/products/${item.handle}">
                                <img src="${item_image}" alt="${item_title}">
                            </a>
                        </div>
                        <div class="cart-item-details cwrap">
                            <div class="cart-item-left">
                                <h3 class="cart-item-title">
                                    <a href="/products/${item.handle}">${item_title}</a>
                                </h3>
                                <div class="cart-item-options">
                                    ${propertiesHtml}
                                </div>
                                <div class="qtty">
                                    <span class="minus">-</span>
                                    <input type="text" name="qtty" value="${item.quantity}">
                                    <span class="plus">+</span>
                                </div>
                            </div>
                            <div class="cart-item-right">
                                <p class="cart-item-price">£${formattedPrice}</p>
                                <a href="#" class="cart-item-remove">Remove</a>
                            </div>
                        </div>
                    </div>
                `);
            }

            const vatAmount = sub_total * 0.20;
            const totalWithVAT = sub_total + vatAmount;

            $totalsContainer.html(`
                <div class="bins-total cwrap">
                    <p><strong>Sub Total</strong></p>
                    <p>£${formatPrice(sub_total.toFixed(2))}</p>
                </div>
                <div class="bins-total cwrap">
                    <p><strong>VAT</strong></p>
                    <p>£${formatPrice(vatAmount.toFixed(2))}</p>
                </div>
                <div class="bins-total cwrap">
                    <p><strong>Total (with VAT)</strong></p>
                    <p>£${formatPrice(totalWithVAT.toFixed(2))}</p>
                </div>
            `);
            
            $('.cart-count').text(cart.item_count);
            $('.bins-cart-float').show();
        } else {
            $itemsContainer.html(`
                <div class="bins-cart-empty">
                    <h3>Your basket is currently empty.</h3>
                    <p>Looks like you haven't added anything yet.</p>
                    <a href="/collections/all" class="button">Shop Now</a>
                </div>
            `);
            $totalsContainer.empty();
            $('.cart-count').text('');
            $('.bins-cart-float').hide();
        }

        hideLoader();

    } catch (err) {
        console.error("Cart fetch error:", err);
    }
}

function loadTidio() {
    const script = document.createElement('script');
    script.src = 'https://code.tidio.co/4t28h01fwfvtgd1syhgcpdwvjry2jx8z.js';
    script.async = true;
    script.defer = true;
    
    script.onload = function() {
        console.log('Tidio loaded successfully');
        openTidioChat();
    };
    
    script.onerror = function() {
        console.error('Failed to load Tidio');
    };
    
    document.head.appendChild(script);
}

function openTidioChat() {
    if (window.tidioChatApi) {
        window.tidioChatApi.open();
        console.log('Tidio chat opened');
    } else {
        let attempts = 0;
        const maxAttempts = 20;
        const interval = setInterval(function() {
            attempts++;
            if (window.tidioChatApi) {
                window.tidioChatApi.open();
                console.log('Tidio chat opened (delayed)');
                clearInterval(interval);
            } else if (attempts >= maxAttempts) {
                console.error('Tidio API not available after waiting');
                clearInterval(interval);
            }
        }, 500);
    }
}

document.addEventListener('DOMContentLoaded', function () {
    const placeholder = document.querySelector('.livechat');
    
    if (!placeholder) return;
    
    placeholder.addEventListener('click', function() {
        placeholder.remove();
        loadTidio();
    });
});

$(document).ready(function () {
    var winWidth = $(window).width();

    if (winWidth < 1201) {
        const info = document.querySelector(".info");

        if (!info) return;

        const track = document.createElement("div");
        track.className = "info-slider-track";

        while (info.firstElementChild) {
            track.appendChild(info.firstElementChild);
        }

        info.appendChild(track);

        const speed = 500;
        const delay = 4000;

        function nextSlide() {
            function nextSlide() {
                track.style.transform = "translateX(-100%)";

                setTimeout(() => {
                    track.appendChild(track.firstElementChild);

                    track.style.transition = "none";
                    track.style.transform = "translateX(0)";

                    requestAnimationFrame(() => {
                        requestAnimationFrame(() => {
                            track.style.transition = `transform ${speed}ms ease`;
                        });
                    });
                }, speed);
            }
        }

        setInterval(nextSlide, delay);
    }

    $('.mobile-icon').on('click', function () {
        var $header = $('.site-header');
        var $menu = $('.site-menu');

        var rect = $header[0].getBoundingClientRect();

        $menu.css('top', rect.top + $header.outerHeight());
        
        if ($('body').hasClass('mobile-opened')) {
            $('body').removeClass('mobile-opened');
            $menu.fadeOut();
        } else {
            $('body').addClass('mobile-opened');
            $menu.fadeIn();
        }
    });

    $('.search-icon').on('click', function () {
        if ($('body').hasClass('search-opened')) {
            $('body').removeClass('search-opened');
            $('.header-search').fadeOut();
        } else {
            $('body').addClass('search-opened');
            $('.header-search').fadeIn();
        }
    });

    $('.site-menu ul li.menu-has-children > a').on('click', function (e) {
        e.preventDefault();

        if (winWidth < 1201) {
            if ($(this).parent().hasClass('dropdown-opened')) {
                $(this).parent().removeClass('dropdown-opened');
                $(this).parent().find('.dropdown').slideUp();
            } else {
                $('.site-menu ul li.menu-has-children').removeClass('dropdown-opened');
                $('.site-menu .dropdown').slideUp();

                $(this).parent().addClass('dropdown-opened');
                $(this).parent().find('.dropdown').slideDown();
            }
        }
    });
    
    $('.faq h3').on('click', function () { 
        if ($(this).parent().hasClass('active')) {
            $(this).parent().removeClass('active');
            $(this).parent().find('.faq-answer').slideUp();
        } else {
            $(this).parent().addClass('active');
            $(this).parent().find('.faq-answer').slideDown();
        }
    });

    $('.header-cart').on('click', function (e) {
        e.preventDefault();
        
        openCart();
    });

    $('.bins-cart-close, .bins-cart-overlay').on('click', function (e) {
        e.preventDefault();
        
        closeCart();
    });

    $(document).on('click', '.cart-item-remove', function (e) {
        e.preventDefault();

        showLoader();
        $('.bins-cart-float').hide();
        
        const cart_key = $(this).closest('.bins-cart-item').attr('data-id');

        let formData = {
            id: cart_key,
            quantity: 0
        };

        return fetch(window.Shopify.routes.root + "cart/change.js", {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(formData)
        })
        .then(res => res.json())
        .then(cart => {
            renderCartDrawer();
        })
        .catch(err => console.error("Error removing item:", err));
    });

    $(document).on('click', '.qtty span', function() {
        let $btn = $(this).parent();
        let $input = $btn.find('input[name="qtty"]');
        let currentVal = parseInt($input.val(), 10) || 1;

        if ($(this).hasClass('plus')) {
            currentVal++;
        } else {
            currentVal = currentVal > 1 ? currentVal - 1 : 1;
        }

        $input.val(currentVal);

        const item_id = $(this).closest('.bins-cart-item').attr('data-id');
        
        let updates = {
            [item_id]: currentVal
        };

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
            }).then(response => {
                renderCartDrawer();   
            }
        ).catch((error) => {
            console.error('Error:', error);
        });
    });

    $(document).on('change', 'input[name="qtty"]', function() {
        const currentVal = $(this).val();
        const item_id = $(this).closest('.bins-cart-item').attr('data-id');
        
        let updates = {
            [item_id]: currentVal
        };

        fetch(window.Shopify.routes.root + 'cart/update.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({ updates })
            }).then(response => {
                renderCartDrawer();   
            }
        ).catch((error) => {
            console.error('Error:', error);
        });
    });

    function changePSPrice(status) {
        if (status == 'checked') {
            $('.ps-grid-price').each(function () {
                const unit_price = parseFloat($(this).find('span').attr('data-price'));
                const vat_price = addVat(unit_price);
                $(this).find('span').text('£' + formatPrice(vat_price));
            });
        } else if (status == 'unchecked') {
            $('.ps-grid-price').each(function () {
                const unit_price = parseFloat($(this).find('span').attr('data-price'));
                $(this).find('span').text('£' + formatPrice(unit_price));
            });
        }
    }

    function changeCollectionPrice(status) {
        if (status == 'checked') {
            $('.product-card').each(function () {
                const unit_price = parseFloat($(this).find('.pprice span').attr('data-price'));
                const vat_price = addVat(unit_price);
                $(this).find('.pprice span').text('£' + formatPrice(vat_price));
            });
        } else if (status == 'unchecked') {
            $('.product-card').each(function () {
                const unit_price = parseFloat($(this).find('.pprice span').attr('data-price'));
                $(this).find('.pprice span').text('£' + formatPrice(unit_price));
            });
        }
    }

    $('input[name="header-switch"]').on('change', function() {
        if ($(this).is(':checked')) {
            $('.header .switch-wrapper').addClass('header-vat-active');

            if ($('.ps-grid').length) {
                changePSPrice('checked');
            }

            if ($('.collection-wrap').length) {
                changeCollectionPrice('checked');
            }

            if ($('.product-main').length) {
                $('#vat-switch').prop('checked', true).trigger('change');
            }

            $('.header .vat-text').text('Inc Vat.');
            setCookie('vat_active', 1, 1);
        } else {
            $('.header .switch-wrapper').removeClass('header-vat-active');

            if ($('.ps-grid').length) {
                changePSPrice('unchecked');
            }

            if ($('.collection-wrap').length) {
                changeCollectionPrice('unchecked');
            }

            if ($('.product-main').length) {
                $('#vat-switch').prop('checked', false).trigger('change');
            }

            $('.header .vat-text').text('Ex Vat.');
            setCookie('vat_active', 0, 1);
        }
    });

    const vat_active = getCookie('vat_active');
    
    if (vat_active) {
        $('input[name="header-switch"]').prop('checked', true).trigger('change');
    } else {
        $('input[name="header-switch"]').prop('checked', false).trigger('change');
    }

    $('.footer-menu-heading').on('click', function () {
        if (winWidth < 1201) {
            if ($(this).parent().hasClass('footer-menu-opened')) {
                $('.site-footer .col5').removeClass('footer-menu-opened');
                $('.footer-menu').hide();
            } else {
                $('.site-footer .col5').removeClass('footer-menu-opened');
                $('.footer-menu').hide();

                $(this).parent().addClass('.footer-menu-opened');
                $(this).parent().find('.footer-menu').slideDown('fast');
            }
        }
    });

    renderCartDrawer();
});